import { render } from "./state-actions.vue?vue&type=template&id=5d993ea0"
import script from "./state-actions.vue?vue&type=script&lang=js"
export * from "./state-actions.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__